/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { CarouselSlider } from '@/components/blocks/Carousel';
import { CenterContainer } from '@/components/blocks/CenterContainer';
import {
	DpAccordion,
	DpAccordionDetails,
	DpAccordionFrame,
	DpAccordionSummary,
} from '@/components/blocks/DpAccordion';
import { DpAccordionHelpCenter } from '@/components/blocks/DpAccordionHelpCenter';
import { DpAccordionSeason } from '@/components/blocks/DpAccordionSeason';
import {
	DpArticleContainer,
	DpArticleContent,
	DpArticleContentFrame,
	DpArticleContentTitle,
	DpArticleHeader,
	DpArticleHeaderBack,
	DpArticleHeaderCategory,
	DpArticleText,
	DpArticleTitle,
} from '@/components/blocks/DpArticle';
import {
	DpArticleCard,
	DpArticleCardEmphasis,
	DpArticleCardGrid,
	DpArticleCardText,
} from '@/components/blocks/DpArticleCard';
import { DpBenefitCoupon } from '@/components/blocks/DpBenefitCoupon';
import { DpBenefit, DpBenefits } from '@/components/blocks/DpBenefits';
import { DpBenefitsContainer } from '@/components/blocks/DpBenefitsContainer';
import { BenefitsGray, DpBenefitGray } from '@/components/blocks/DpBenefitsGray';
import { DpBlogCard } from '@/components/blocks/DpBlogCard';
import { DpBlogGrid } from '@/components/blocks/DpBlogGrid';
import { DpBorderRefunds } from '@/components/blocks/DpBorderRefunds';
import { DpBottomContainer } from '@/components/blocks/DpBottomContainer';
import { DpContainer } from '@/components/blocks/DpContainer';
import { DpCustomDivider } from '@/components/blocks/DpCustomDivider';
import {
	DpFooterAccordionLink,
	DpFooterAccordionLinkFrame,
} from '@/components/blocks/DpGroupAccordionPageLink';
import { DpFooterGroupLink, DpFooterGroupLinkFrame } from '@/components/blocks/DpGroupPageLink';
import {
	DpHelpCenterLi,
	DpHelpCenterOl,
	DpHelpCenterP,
	DpHelpCenterSubtitle,
	DpHelpCenterTitle,
	DpHelpCenterUl,
} from '@/components/blocks/DpHelpCenter';
import { CountdownTimer } from '@/components/blocks/DpLibrary/CounterDown';
import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import DpAutoHidden from '@/components/blocks/DpLibrary/DpAutoHidden';
import { DpBuenFinBannerAds } from '@/components/blocks/DpLibrary/DpBFBannerAds';
import { DpBannerAds, DpPlpBannerAds } from '@/components/blocks/DpLibrary/DpBannerAds';
import { DpBannerAdsText } from '@/components/blocks/DpLibrary/DpBannerAdsText';
import { DpBannerCheckout } from '@/components/blocks/DpLibrary/DpBannerCheckout';
import { DpBannersTwoAds } from '@/components/blocks/DpLibrary/DpBannersTwoAds';
import { DpBenefitsDistribuidor } from '@/components/blocks/DpLibrary/DpBenefitsDistribuidor';
import { DpBestOffer } from '@/components/blocks/DpLibrary/DpBestOffer';
import { DpBreadcrumbCard } from '@/components/blocks/DpLibrary/DpBreadcrumbCard';
import { DpBreadcrumbCardFrame } from '@/components/blocks/DpLibrary/DpBreadcrumbCardFrame';
import { DpBreadcrumbTrail } from '@/components/blocks/DpLibrary/DpBreadcrumbTrail';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { DpButtonEmail } from '@/components/blocks/DpLibrary/DpButtonEmail';
import { DpButtonForm } from '@/components/blocks/DpLibrary/DpButtonForm';
import { DpButtonPhone } from '@/components/blocks/DpLibrary/DpButtonPhone';
import { DpButtonWhatsApp } from '@/components/blocks/DpLibrary/DpButtonWhatsApp';
import { DpCardCategory } from '@/components/blocks/DpLibrary/DpCardCategory';
import { DpCardDistribuidor } from '@/components/blocks/DpLibrary/DpCardDistribuidor';
import { DpCardIconInformation } from '@/components/blocks/DpLibrary/DpCardIconInformation';
import { DpCardIconInformationGrid } from '@/components/blocks/DpLibrary/DpCardIconInformationGrid';
import { DpCardTendence } from '@/components/blocks/DpLibrary/DpCardTendence';
import { DpCarouselContent } from '@/components/blocks/DpLibrary/DpCarouselContent';
import { DpCatalogEntryCarouselHeader } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader';
import { DpCatalogEntryCarouselHeaderContent } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader/parts/DpCatalogEntryCarouselHeaderContent';
import { DpCatalogEntryCarouselSeeMore } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselSeeMore';
import { DpContact } from '@/components/blocks/DpLibrary/DpContact';
import { DpContentBenefits } from '@/components/blocks/DpLibrary/DpContentBenefits';
import { DpDepartmentCard } from '@/components/blocks/DpLibrary/DpDepartmentCard';
import { DpFiraLive } from '@/components/blocks/DpLibrary/DpFiraLive';
import { DpFloatingCard } from '@/components/blocks/DpLibrary/DpFloatingCard';
import { DpFloatingWhatsApp } from '@/components/blocks/DpLibrary/DpFloatingWhatsApp';
import { DpFooterLinks } from '@/components/blocks/DpLibrary/DpFooterLinks/indext';
import { DpFooterTerminos } from '@/components/blocks/DpLibrary/DpFooterTerminos';
import {
	DpCheckboxForm,
	DpForm,
	DpFormButton,
	DpFormInput,
	DpFormInputHidden,
} from '@/components/blocks/DpLibrary/DpForm';
import { DpFullContainer } from '@/components/blocks/DpLibrary/DpFullContainer';
import { DpGridCard, DpGridCards } from '@/components/blocks/DpLibrary/DpGridCard';
import { DpGridCardAD } from '@/components/blocks/DpLibrary/DpGridCardAd';
import { DpGridCardFrame } from '@/components/blocks/DpLibrary/DpGridCardFrame';
import { DpCardImage, DpGridImages } from '@/components/blocks/DpLibrary/DpGridImages';
import { DpGridTendence } from '@/components/blocks/DpLibrary/DpGridTendence';
import { DpHeaderTemporalCategory } from '@/components/blocks/DpLibrary/DpHeaderTemporalCategory';
import { DpInformativeFrame } from '@/components/blocks/DpLibrary/DpInformativeFrame';
import { DpInputTextField } from '@/components/blocks/DpLibrary/DpInputTextField';
import { DpMark } from '@/components/blocks/DpLibrary/DpMark';
import { DpMarksSlider } from '@/components/blocks/DpLibrary/DpMarksSlider';
import { DpMarksSliderTemp } from '@/components/blocks/DpLibrary/DpMarksSliderTemp';
import { DpMiniCardCategory } from '@/components/blocks/DpLibrary/DpMiniCardCategory';
import { DpNextBenefit } from '@/components/blocks/DpLibrary/DpNextBenefit';
import { DpParagraphCustom } from '@/components/blocks/DpLibrary/DpParagraphCustom';
import {
	DpPlpDescription,
	DpPlpTitle,
	DpPlpTitleFrame,
} from '@/components/blocks/DpLibrary/DpPlpTitle';
import { DpPopUpPromotion } from '@/components/blocks/DpLibrary/DpPopUpPromotion';
import {
	DpPopulateBlock,
	DpPopulateBlockMobile,
	DpPopulateCategory,
	DpPopulateLink,
} from '@/components/blocks/DpLibrary/DpPopulate';
import { DpProductGridCard } from '@/components/blocks/DpLibrary/DpProductGridCard';
import { DpPromo } from '@/components/blocks/DpLibrary/DpPromo';
import { DpPromotionImage } from '@/components/blocks/DpLibrary/DpPromotionImage';
import { DpRenderDesktop, DpRenderMobile } from '@/components/blocks/DpLibrary/DpRender';
import {
	DpRichContentBanner,
	DpRichContentDescription,
	DpRichContentFrame,
	DpRichContentGridAd,
	DpRichContentGridAds,
	DpRichContentTitle,
} from '@/components/blocks/DpLibrary/DpRichContent';
import { DpSEOFrame } from '@/components/blocks/DpLibrary/DpSEOFrame';
import { DpSEOSection } from '@/components/blocks/DpLibrary/DpSEOSection';
import { DpSEOText } from '@/components/blocks/DpLibrary/DpSEOText';
import { DpSEOTitle } from '@/components/blocks/DpLibrary/DpSEOTitle';
import { DpScrollHeader } from '@/components/blocks/DpLibrary/DpScrollHeader';
import { DpScrollSubtitle } from '@/components/blocks/DpLibrary/DpScrollSubtitle';
import { DpScrollTitle } from '@/components/blocks/DpLibrary/DpScrollTitle';
import { DpSelect } from '@/components/blocks/DpLibrary/DpSelect';
import { DpStripBenefit } from '@/components/blocks/DpLibrary/DpStripBenefit';
import {
	DpTabLink,
	DpTabLinkContent,
	DpTabLinkContentLink,
	DpTabLinksContainer,
} from '@/components/blocks/DpLibrary/DpTabsLinks';
import { DpTitleCustom } from '@/components/blocks/DpLibrary/DpTitleCustom';
import { DpTitleMobile } from '@/components/blocks/DpLibrary/DpTitleMobile';
import { DpTitles } from '@/components/blocks/DpLibrary/DpTitles';
import { DpVideo } from '@/components/blocks/DpLibrary/DpVideo';
import { DpVideoDistribuidor } from '@/components/blocks/DpLibrary/DpVideoDistribuidor';
import { DpVideoWithBackground } from '@/components/blocks/DpLibrary/DpVideoWithBackground';
import { DpOfferChip, DpOfferChipGrid } from '@/components/blocks/DpOfferChip';
import {
	DpOrderConfirmationAction,
	DpOrderConfirmationButton,
	DpOrderConfirmationCard,
	DpOrderConfirmationContent,
	DpOrderConfirmationDescription,
	DpOrderConfirmationImg,
	DpOrderConfirmationTitle,
} from '@/components/blocks/DpOrderConfirmationCard';
import { DpPopulateContainer } from '@/components/blocks/DpPopulateContaier';
import { DpSearchBanner } from '@/components/blocks/DpSearchBanner';
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { DpScrollContainer } from '@/components/blocks/ScrollContainer';
import { HelpCenter } from '@/components/content/DpHelpCenter';
import { Box, Button, Container, Grid, MenuItem, Paper, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { FC } from 'react';

export const MUI_ELEMENTS: Record<string, OverridableComponent<any>> = {
	Box,
	Button,
	Container,
	Grid,
	Paper,
};

export const SPECIAL_TAGS: Record<string, FC<any>> = {
	a: Linkable,
	button: DpButton,
	div: Box,
	img: Img,
	hr: DpCustomDivider,
	'dp-accordion': DpAccordion,
	'dp-accordion-season': DpAccordionSeason,
	'dp-accordion-help-center': DpAccordionHelpCenter,
	'dp-help-center-title': DpHelpCenterTitle,
	'dp-help-center-subtitle': DpHelpCenterSubtitle,
	'dp-help-center-ul': DpHelpCenterUl,
	'dp-help-center-ol': DpHelpCenterOl,
	'dp-help-center-li': DpHelpCenterLi,
	'dp-help-center-p': DpHelpCenterP,
	'dp-best-offer': DpBestOffer,
	'dp-button': DpButton,
	'dp-card-tendence': DpCardTendence,
	'dp-card-category': DpCardCategory,
	'dp-carousel-content': DpCarouselContent,
	'dp-mark': DpMark,
	'dp-blog-grid': DpBlogGrid,
	'dp-blog-card': DpBlogCard,
	'dp-border-refunds': DpBorderRefunds,
	'dp-plp-banner-ads': DpPlpBannerAds,
	'dp-banner-ads': DpBannerAds,
	'dp-banner-ads-text': DpBannerAdsText,
	'dp-article-container': DpArticleContainer,
	'dp-article-header': DpArticleHeader,
	'dp-article-header-back': DpArticleHeaderBack,
	'dp-article-header-category': DpArticleHeaderCategory,
	'dp-article-title': DpArticleTitle,
	'dp-article-text': DpArticleText,
	'dp-article-content-frame': DpArticleContentFrame,
	'dp-article-content': DpArticleContent,
	'dp-article-content-title': DpArticleContentTitle,
	'dp-article-card-grid': DpArticleCardGrid,
	'dp-article-card': DpArticleCard,
	'dp-article-card-text': DpArticleCardText,
	'dp-article-card-emphasis': DpArticleCardEmphasis,
	'dp-promotion-image': DpPromotionImage,
	'dp-banner-checkout': DpBannerCheckout,
	'dp-catalog-entry-carousel-header': DpCatalogEntryCarouselHeader,
	'dp-search-catalog-entry-carousel-header': DpCatalogEntryCarouselHeaderContent,
	'dp-product-grid-card': DpProductGridCard,
	'dp-titles': DpTitles,
	'dp-seo-frame': DpSEOFrame,
	'dp-seo-section': DpSEOSection,
	'dp-seo-title': DpSEOTitle,
	'dp-seo-text': DpSEOText,
	'dp-card-icon-information': DpCardIconInformation,
	'dp-card-icon-information-grid': DpCardIconInformationGrid,
	'dp-banners-two-ads': DpBannersTwoAds,
	'dp-input-text-field': DpInputTextField,
	'dp-button-form': DpButtonForm,
	'dp-title-custom': DpTitleCustom,
	'dp-checkbox-form': DpCheckboxForm,
	'dp-video': DpVideo,
	'dp-video-with-background': DpVideoWithBackground,
	'dp-fira-live': DpFiraLive,
	'dp-button-phone': DpButtonPhone,
	'dp-button-whats-app': DpButtonWhatsApp,
	'dp-button-email': DpButtonEmail,
	'dp-form': DpForm,
	'dp-form-input': DpFormInput,
	'dp-form-input-hidden': DpFormInputHidden,
	'dp-form-checkbox': DpCheckboxForm,
	'dp-form-button': DpFormButton,
	'dp-department-card': DpDepartmentCard,
	'dp-benefits-gray': BenefitsGray,
	'dp-select': DpSelect,
	'dp-grid-card-frame': DpGridCardFrame,
	'dp-select-option': MenuItem,
	'dp-mini-card-category': DpMiniCardCategory,
	'dp-benefit-coupon': DpBenefitCoupon,
	'dp-content-center': CenterContainer,
	'dp-h2': DpH2,
	'dp-scroll-frame': DpScrollContainer,
	'dp-strip-benefit': DpStripBenefit,
	'dp-next-benefit': DpNextBenefit,
	'dp-marks-slider': DpMarksSlider,
	'dp-marks-slider-temp': DpMarksSliderTemp,
	'dp-carousel-slider': CarouselSlider,
	'dp-content-benefits': DpContentBenefits,
	'dp-render-mobile': DpRenderMobile,
	'dp-render-desktop': DpRenderDesktop,
	'dp-expandable-item': DpPopulateBlockMobile,
	'dp-populate-category': DpPopulateCategory,
	'dp-populate-link': DpPopulateLink,
	'dp-populate-block': DpPopulateBlock,
	'dp-grid-cards': DpGridCards,
	'dp-grid-card': DpGridCard,
	'dp-tab-link-container': DpTabLinksContainer,
	'dp-tab-link': DpTabLink,
	'dp-tab-link-content': DpTabLinkContent,
	'dp-tab-link-content-link': DpTabLinkContentLink,
	'dp-contact': DpContact,
	'dp-paragraph-custom': DpParagraphCustom,
	'dp-promo': DpPromo,
	'dp-auto-hidden': DpAutoHidden,
	'dp-catalog-entry-carousel-see-more': DpCatalogEntryCarouselSeeMore,
	'dp-informative-frame': DpInformativeFrame,
	'dp-plp-breadcrumb-card-frame': DpBreadcrumbCardFrame,
	'dp-plp-breadcrumb-card': DpBreadcrumbCard,
	'dp-buenfin-banner-ads': DpBuenFinBannerAds,
	'dp-footer-links': DpFooterLinks,
	'dp-footer-terminos': DpFooterTerminos,
	'dp-container': DpContainer,
	'dp-bottom-container': DpBottomContainer,
	'dp-grid-tendence': DpGridTendence,
	'dp-cards-distribuidor': DpCardDistribuidor,
	'dp-video-distribuidor': DpVideoDistribuidor,
	'dp-benefits-distribuidor': DpBenefitsDistribuidor,
	'dp-benefits-container': DpBenefitsContainer,
	'dp-scroll-title': DpScrollTitle,
	'dp-scroll-subtitle': DpScrollSubtitle,
	'dp-scroll-header': DpScrollHeader,
	'dp-grid-card-ad': DpGridCardAD,
	'dp-populate-container': DpPopulateContainer,
	'dp-floating-card': DpFloatingCard,
	'dp-title-mobile': DpTitleMobile,
	'dp-floating-whatsapp': DpFloatingWhatsApp,
	'dp-full-container': DpFullContainer,
	'dp-plp-title-frame': DpPlpTitleFrame,
	'dp-plp-title': DpPlpTitle,
	'dp-plp-description': DpPlpDescription,
	'dp-breadcrumb-trail': DpBreadcrumbTrail,
	'dp-pop-up-promotion': DpPopUpPromotion,
	'dp-grid-images': DpGridImages,
	'dp-card-image': DpCardImage,
	'dp-countdown-timer': CountdownTimer,
	'dp-rich-content-frame': DpRichContentFrame,
	'dp-rich-content-title': DpRichContentTitle,
	'dp-rich-content-description': DpRichContentDescription,
	'dp-rich-content-banner': DpRichContentBanner,
	'dp-rich-content-grid-ads': DpRichContentGridAds,
	'dp-rich-content-grid-ad': DpRichContentGridAd,
	'dp-header-temporal-category': DpHeaderTemporalCategory,
	'dp-help-center': HelpCenter,
	'dp-footer-accordion-link-frame': DpFooterAccordionLinkFrame,
	'dp-footer-accordion-link': DpFooterAccordionLink,
	'dp-footer-group-link-frame': DpFooterGroupLinkFrame,
	'dp-footer-group-link': DpFooterGroupLink,
	'dp-order-confirmation-card': DpOrderConfirmationCard,
	'dp-order-confirmation-img': DpOrderConfirmationImg,
	'dp-order-confirmation-title': DpOrderConfirmationTitle,
	'dp-order-confirmation-description': DpOrderConfirmationDescription,
	'dp-order-confirmation-content': DpOrderConfirmationContent,
	'dp-order-confirmation-action': DpOrderConfirmationAction,
	'dp-order-confirmation-button': DpOrderConfirmationButton,
	'dp-search-banner': DpSearchBanner,
	'dp-benefits': DpBenefits,
	'dp-benefit': DpBenefit,
	'dp-benefits-gray-frame': BenefitsGray,
	'dp-benefit-gray': DpBenefitGray,
	'dp-offer-chip': DpOfferChip,
	'dp-offer-chip-grid': DpOfferChipGrid,
	'dp-accordion-frame': DpAccordionFrame,
	'dp-accordion-summary': DpAccordionSummary,
	'dp-accordion-details': DpAccordionDetails,
};

export const TYPOGRAPHY_TAGS: Record<string, OverridableComponent<any>> = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'p:body1',
	'strong',
	'overline',
].reduce(
	(named, key) => ({
		...named,
		[key.split(':').at(0) || '']: (props: any) => (
			<Typography variant={key.split(':').at(-1)} {...props} />
		),
	}),
	{}
);
